// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3FsdG","footer":"ModalCreateQualiphyProcedure_footer__5lzRq","additionData":"ModalCreateQualiphyProcedure_additionData__kAq_S"};